export const status = Object.freeze({
  unchecked: 0,
  checked: 1,
  indeterminate: -1,
});
